import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Button } from '../Button';
import { Field, getId } from '../Field/Field';
import { textInputWidth } from '../Field/Field.styled';
import { HidePreviewActionIcon, PreviewActionIcon } from '../icons';
import { useThemeColor } from '../Theme';
import { useTranslate } from '../util';
import { TextInput } from './TextInput';
export function PasswordField(props) {
  var id = getId(props);
  return /*#__PURE__*/React.createElement(Field, _extends({}, props, {
    htmlFor: id
  }), /*#__PURE__*/React.createElement(Password, _extends({
    maxWidth: textInputWidth
  }, props, {
    id: id
  })));
}
export function Password(props) {
  var _inputRef = React.useRef();
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    inFocus = _React$useState2[0],
    setInFocus = _React$useState2[1];
  var _React$useState3 = React.useState(true),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    maskPassword = _React$useState4[0],
    setMaskPassword = _React$useState4[1];
  var t = useTranslate();
  var actionIconColor = useThemeColor('secondaryActionIcon');
  function _onBlur(event) {
    var _inputRef$current, _inputRef$current$par;
    // use document.activeElement for IE (relatedTarget is not set correctly but the activeElement is updated before blur is called)
    var newTarget = event.relatedTarget || document.activeElement;
    if (!((_inputRef$current = _inputRef.current) !== null && _inputRef$current !== void 0 && (_inputRef$current$par = _inputRef$current.parentNode) !== null && _inputRef$current$par !== void 0 && _inputRef$current$par.contains(newTarget))) {
      setInFocus(false);
      setMaskPassword(true);
    }
  }
  function onClickShowHide() {
    var _inputRef$current2, _inputRef$current3;
    setMaskPassword(function (mask) {
      return !mask;
    });
    (_inputRef$current2 = _inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.focus();
    // Force Chrome to keep the cursor where it was, timeout required to have Chrome handle this after it sets the cursor to the start of the input
    var cursorPosition = (_inputRef$current3 = _inputRef.current) === null || _inputRef$current3 === void 0 ? void 0 : _inputRef$current3.selectionStart;
    setTimeout(function () {
      if (cursorPosition) {
        var _inputRef$current4;
        (_inputRef$current4 = _inputRef.current) === null || _inputRef$current4 === void 0 ? void 0 : _inputRef$current4.setSelectionRange(cursorPosition, cursorPosition);
      }
    }, 0);
  }
  return /*#__PURE__*/React.createElement(TextInput, _extends({}, props, {
    type: maskPassword ? 'password' : 'text',
    inputRef: function inputRef(node) {
      return _inputRef.current = node;
    },
    secondaryIcon: inFocus ? /*#__PURE__*/React.createElement(Button.IconOnly, {
      icon: maskPassword ? PreviewActionIcon : HidePreviewActionIcon,
      size: 21,
      title: maskPassword ? t('citrix-ui:show_password') : t('citrix-ui:hide_password'),
      onClick: function onClick() {
        onClickShowHide();
      },
      onBlur: function onBlur(event) {
        _onBlur(event);
      },
      color: actionIconColor
    }) : undefined,
    onFocus: function onFocus(event) {
      var _props$onFocus;
      (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 ? void 0 : _props$onFocus.call(props, event);
      setInFocus(true);
    },
    onBlur: function onBlur(value, event) {
      var _props$onBlur;
      (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 ? void 0 : _props$onBlur.call(props, value, event);
      _onBlur(event);
    }
  }));
}